import { Button } from "@/components/ui/button";
import { useState, useEffect, useRef } from "react";
import HeroRight from "@/assets/KaratRight.svg";
import HeroImageMobile from "@/assets/HeroImageMobile.png"
import CrazyDesktop from "@/assets/CrazyDesktop.svg";
import CrazyMobile from "@/assets/CrazyMobile.svg";
import { WaitlistPopup } from "@/components/Waitlistpopup";
import scrolldown from "@/assets/ScrollDown2.gif";
import Primary from "@/assets/Hover-Bg-Primary.png";
import Secondary from "@/assets/Hover-Bg-Secondary.png";
import lottibtn from "@/assets/PrimaryBg.json";
import Lottie from "lottie-react";
import { useLottie } from "lottie-react";
import { HoverBorderGradient } from "../components/ui/hover-border-gradient";
import { getOrCreateUserId } from "@/lib/session";
import { sendEvent } from "@/lib/googleSheet";

export const Hero = () => {
  const [waitlistClicked, setWaitlistClicked] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const animationRef = useRef(null);
  const [animatedNumber, setAnimatedNumber] = useState(0);
  const options = {
    animationData: lottibtn,
    loop: true
  };
  const { View } = useLottie(options);

  // MOBILE LOTTIE
  const mobileOptions = {
    animationData: lottibtn,
    loop: true,
    renderer: "svg",
  };
  const { View: MobileView } = useLottie(mobileOptions);

  const handleWaitlistClick = () => {
    const userId = getOrCreateUserId();
    sendEvent(userId, "JOIN_WAIT_LIST_CLICK_2").catch(() => { });

    setWaitlistClicked(true);
    setTimeout(() => setWaitlistClicked(false), 600);
    window.location.href = "https://web.karatclub.in/";
    // setIsPopupOpen(true);
  };

  const BASE = 2500;
  const RATE_PER_HOUR = 103; // 103 people per hour
  const START_HOUR = 8; // 8 AM
  const ACTIVE_HOURS = 16; // 8 AM → 12 AM

  const getAnimatedTargetNumber = () => {
    const now = new Date();
    const hour = now.getHours();
    // Freeze window: 12 AM → 7:59 AM
    if (hour < START_HOUR) {
      return BASE + ACTIVE_HOURS * RATE_PER_HOUR; // 4180
    }
    // Active window: 8 AM → 12 AM
    const elapsedHours = Math.min(hour - START_HOUR, ACTIVE_HOURS);
    return BASE + elapsedHours * RATE_PER_HOUR;
  };

  const targetNumber = getAnimatedTargetNumber();

  useEffect(() => {
    if (animationRef.current) clearInterval(animationRef.current);

    const duration = 2000;
    const steps = 60;
    const inc = targetNumber / steps;
    let step = 0;

    setAnimatedNumber(0);

    animationRef.current = setInterval(() => {
      step++;
      setAnimatedNumber(v => Math.min(targetNumber, Math.round(inc * step)));
      if (step >= steps) clearInterval(animationRef.current);
    }, duration / steps);

    const restart = setInterval(() => {
      step = 0;
      setAnimatedNumber(0);
      animationRef.current = setInterval(() => {
        step++;
        setAnimatedNumber(v => Math.min(targetNumber, Math.round(inc * step)));
        if (step >= steps) clearInterval(animationRef.current);
      }, duration / steps);
    }, 12000);


    return () => {
      clearInterval(animationRef.current);
      clearInterval(restart);
    };
  }, [targetNumber]);



  return (
    <>
      <section className="hero-section relative">
        <div className="w-full">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-0 lg:gap-4">
            <div className="lg:w-6/12 w-full order-first lg:order-2 mobile-negative-margin">
              {/* For mobile */}
              <img
                src={HeroImageMobile}
                alt="Hero"
                className="w-full lg:w-full object-contain md:hidden flex"
              />

              {/* For Desktop */}
              <div className="relative w-full lg:w-full overflow-hidden hidden md:flex">
                <img
                  src={HeroRight}
                  alt="Hero"
                  className="w-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#0D0D0D]" />
              </div>
            </div>

            {/* LEFT CONTENT COLUMN - 6/12 width */}
            <div className="lg:w-6/12 lg:text-left lg:pr-8 relative mobile-negative-margin pl-4 md:pl-0 flex flex-col">
              <div className="flex-grow">
                <img
                  src={CrazyDesktop}
                  alt="Hero Header"
                  className="hidden lg:block w-full max-w-none"
                />

                <img
                  src={CrazyMobile}
                  alt="Mobile Hero Header"
                  className="lg:hidden w-full"
                />

                {/* DESKTOP TEXT - Visible only on desktop */}
                <p className="hidden md:block text-sm sm:text-base md:text-lg font-regular text-[#F7F7F7] mb-4 sm:mb-5 md:mb-6 mt-3 sm:mt-4 md:mt-5 lg:mt-6 leading-relaxed pr-2">
                  Access premium benefits across travel, electronics, dining, and more, without changing the way you invest.
                </p>

                {/* MOBILE TEXT - Visible only on mobile */}
                <p className="md:hidden text-sm sm:text-base md:text-lg font-regular text-[#FFFFFF99] mb-4 sm:mb-5 md:mb-6 mt-3 sm:mt-4 md:mt-5 lg:mt-6 leading-relaxed pr-2">
                  Access premium benefits across travel, electronics, dining, and more, without changing the way you invest.
                </p>

                {/* DESKTOP VERSION - New Join Waitlist Button */}
                <div
                  className="hidden lg:block mb-2"
                  style={{ width: "100%", maxWidth: "40%", marginTop: '42px' }}
                >
                  <HoverBorderGradient
                    onClick={handleWaitlistClick}
                    className="relative overflow-hidden cursor-pointer group w-full rounded-lg"
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                    style={{
                      border: "1px solid #313137",
                      height: 48,
                      background: "black",
                    }}
                  >
                    {/* LOTTIE ALWAYS MOUNTED */}
                    <div
                      className={`absolute inset-0 w-full h-[100%] transition-opacity duration-300 ${isHovering ? "opacity-0" : "opacity-100"
                        }`}
                    >
                      {View}
                    </div>

                    {/* SECONDARY IMAGE */}
                    <img
                      src={Secondary}
                      className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-300 ${isHovering ? "opacity-100" : "opacity-0"
                        }`}
                    />

                    {/* "Join the Waitlist" Text */}
                    <div className="relative z-10 flex items-center justify-center h-full">
                      <span
                        className="text-white font-semibold tracking-wide"
                        style={{
                          fontSize: '20px',
                          textShadow: '0px 2px 4px rgba(0, 0, 0, 0.3)',
                        }}
                      >
                        Join the Club
                      </span>
                    </div>
                  </HoverBorderGradient>
                </div>

                <div className="hidden lg:block mb-2 flex items-center mb-4">
                  <span className="text-[#DBAD71] text-lg font-semibold">
                    {animatedNumber.toLocaleString()}
                  </span>
                  <span className="text-[#FFFFFF99] ml-1">people applied in the last 24 hours</span>
                </div>

                {/* MOBILE VERSION - New Join Waitlist Button */}
                <div className="block lg:hidden w-full flex justify-center mb-10">
                  <HoverBorderGradient
                    onClick={handleWaitlistClick}
                    className="relative overflow-hidden cursor-pointer group"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #313137",
                      padding: 0,
                      background: "transparent",
                      width: "70%",
                      height: "48px",
                      display: 'block'
                    }}
                  >
                    {/* FIXED LOTTIE FOR iPHONE */}
                    <div
                      className="absolute inset-0 pointer-events-none"
                      style={{
                        zIndex: 1,
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        className="absolute inset-0 lottie-mobile"
                        style={{
                          width: "100%",
                          height: "100%",
                          overflow: 'hidden',
                        }}
                      >
                        {MobileView}
                      </div>
                    </div>

                    {/* TEXT */}
                    <div className="relative z-10 flex items-center justify-center h-full">
                      <span
                        className="text-white font-semibold tracking-wide"
                        style={{
                          fontSize: "20px",
                          textShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
                        }}
                      >
                        Join the Club
                      </span>
                    </div>
                  </HoverBorderGradient>
                </div>
                <div className="block lg:hidden flex items-center mb-4 mr-2 justify-center">
                  <span className="text-[#DBAD71] text-sm font-medium">
                    {animatedNumber.toLocaleString()}
                    <span className="text-[#FFFFFF99] font-regular text-sm ml-1">people applied in the last 24 hours</span>
                  </span>

                </div>
              </div>

              {/* SCROLL SECTION - Positioned at bottom aligned with right image */}
              <div className="mt-auto pt-4 lg:pt-0">
                <div className="w-full flex flex-row items-center justify-center lg:justify-between gap-3">
                  <div className="flex items-center justify-center">
                    <p className="text-white text-sm lg:text-base whitespace-nowrap mr-1">Scroll</p>
                    <img src={scrolldown} className="w-8 h-6 lg:w-8 lg:h-8 bg-transparent mr-8" />
                  </div>
                  <div className="hidden lg:block lg:pr-8 w-full max-w-[200px]">
                    <div
                      className="w-full h-[1px] rounded-[19px] opacity-100 md:h-[2px] mt-4"
                      style={{
                        background: 'var(--Border-Seperator, #40404A)',
                        borderColor: 'var(--Border-Seperator, #40404A)'
                      }}
                    >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WaitlistPopup
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        onSubmit={(data) => console.log(data)}
      />
    </>
  );
};